import {Store} from 'extensions/store/lib/store';

export const rmaStore = new Store({name: 'rma'});
